<template>
    <div>
      <Header></Header>
      <div class="box">
      <div class="head-a">
        <img src="static/images/chat.png" alt="">
      </div>
      <div class="content">
        <div class="chat-area" ref="main">
          <div ref="content">
            <div class="chat-item" v-for="(item, index) in chatlist" :key="index">
              <img v-if="item.ut == 0" class="c-i-header-u" src="static/images/tx2.png" alt="">
              <img v-else class="c-i-header" src="static/images/openai.png" alt="">
              <p class="c-p" v-html="item.chat"></p>
              <p style="clear: both;"></p>
            </div>
            <div v-if="isloading" class="quan">
              <div class="loader-8"></div>
            </div>
          </div>
        </div>
        <Alert v-if="message.length > 0" @on-close="test" type="error" closable>{{message}}</Alert>
        <div class="c-i-input">
          <Input style="width: 85%" v-model="userprompt" placeholder="请输入你想问的问题" @keyup.enter.native="sendMsg"/>
          <Button style="width: 14%" @click="sendMsg" type="primary" icon="ios-paper-plane">发送</Button>
        </div>
      </div>
      <div class="intro">
        <p class="">使用说明</p>
        <p>1）提问时问题要描述的详细一些，比如：</p>
        <p class="sec-info">三国演义里面的关羽是怎么样的人</p>
        <p>2）问题不能太长，别超过1000字</p>
        <p>3）收费标准：</p>
        <p class="sec-info">1个月20次查询 9元</p>
        <!-- <p class="sec-info">3个月300次查询 29元</p> -->
        <!-- <p class="sec-info">6个月1300次查询 99元</p> -->
        <p class="sec-info">默认送3次查询</p>
        <p class="tip-info">提示：后端采用openai公司的服务，所以存在接口返回失败的不稳定情况，这个是正常现象</p>
      </div>
      </div>
    </div>
</template>
<script>
import Header from './header'

export default {
  components: {
    Header
  },

  data () {
    return {
      visible: false,
      userprompt: '',
      message: '',
      isloading: false,
      t1: '2022年11月，OpenAI推出人工智能聊天工具ChatGPT，迅速在世界范围内引发关注。两个多月后，ChatGPT热度不减。国内也涌现了一批名字中包含“ChatGPT”的微信公众号、小程序产品。（此前报道>>）2022年11月，OpenAI推出人工智能聊天工具ChatGPT，迅速在世界范围内引发关注。两个多月后，ChatGPT热度不减。国内也涌现了一批名字中包含“ChatGPT”的微信公众号、小程序产品。（此前报道>>）2022年11月，OpenAI推出人工智能聊天工具ChatGPT，迅速在世界范围内引发关注。两个多月后，ChatGPT热度不减。国内也涌现了一批名字中包含“ChatGPT”的微信公众号、小程序产品。（此前报道>>）2022年11月，OpenAI推出人工智能聊天工具ChatGPT，迅速在世界范围内引发关注。两个多月后，ChatGPT热度不减。国内也涌现了一批名字中包含“ChatGPT”的微信公众号、小程序产品。（此前报道>>）',
      chatlist: [
      ],
      columns: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '说明',
          key: 'introduce'
        },
        {
          title: '价格',
          key: 'price'
        }
      ],
      data: [
        {
          name: '求月汇总.py',
          introduce: '按关键词+地区将数据做月汇总',
          price: '10元'
        },
        {
          name: '求月均值.py',
          introduce: '按关键词+地区将数据做月算数平均值',
          price: '10元'
        },
        {
          name: '求年汇总.py',
          introduce: '按关键词+地区将数据做年汇总',
          price: '10元'
        },
        {
          name: '求年均值.py',
          introduce: '按关键词+地区将数据做年算数平均值',
          price: '10元'
        },
        {
          name: '文件合并.py',
          introduce: '将多个结果文件直接拼接到一起',
          price: '10元'
        }
      ]
    }
  },
  mounted () {
    this.scrollBottom()
  },
  watch: {
    chatlist: {
      handler (newVal, oldVal) {
        // console.log('深度监听', newVal, oldVal)
        this.scrollBottom()
      },
      deep: true
    }
  },
  methods: {
    test () {
      // 关闭错误提示
      this.message = ''
    },
    sendMsg () {
      if (this.userprompt.length === 0) {
        // const msg = this.$Message.loading({
        //   content: 'Loading...',
        //   duration: 0
        // })
        this.$Message.info('请输入需要查询的内容')
        // this.visible = true
        return
      }
      // 关闭错误提示
      this.message = ''
      let obj = {
        ut: 0,
        chat: this.userprompt
      }
      this.chatlist.push(obj)
      const userprompt = this.userprompt
      this.userprompt = ''
      this.isloading = true
      // 发送消息到服务器，然后前台不许在输入内容，loading状态
      var url = this.$store.state.baseurl + '/mapi/gpt/completions'
      // const that = this
      let formData = new FormData()
      const that = this
      formData.append('prompt', userprompt)
      this.axios.post(
        url,
        formData
      ).then(function (res) {
        that.isloading = false
        if (res.data.code === 200) {
          var vinfo = res.data.data.replace('\n', '<br>')
          let obj = {
            ut: 1,
            chat: vinfo
          }
          that.chatlist.push(obj)
          console.log('response ', vinfo)
        } else {
          that.message = res.data.msg
          console.log('completions error', res)
        }
      }).catch((e) => {
        that.isloading = false
        console.log('获取数据失败', e)
        that.message = '获取数据失败'
      })
    },
    scrollBottom () {
      // 滚动到div到最底部。需在有新消息的调用一下
      this.$nextTick(() => {
        this.$refs.main.scrollTop = this.$refs.content.scrollHeight
      })
    },
    scrollEvent (e) {
      console.log(e)
      if (e.srcElement.scrollTop + e.srcElement.clientHeight === e.srcElement.scrollHeight) {
        console.log('嘿嘿我在底部触发了')
      }
    }
  }
}
</script>
<style lang="less" scoped>
a:hover {
  color: #177ff5;
}
// a:link{color: #177ff5;}
a:visited{color: #fff;}
.tao {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
  padding: 4px 8px;
  border-radius: 5px;
}
h3 {
  margin: 20px 0;
}
.box {
  margin: 20px auto;
  width: 80%;
}
.head-a {
  background: #4ba680;
  border-radius: 7px;
  padding: 22px 20px 15px;
}
.content {
  text-align: left;
  margin: 20px 0;
  height: 65vh;
  // border:solid 1px #d58512;
}
.chat-area {
  width: 100%;
  height: 92%;
  padding: 20px 10px 20px 20px;
  overflow: auto;
  font-size: 19px;
  border: solid 1px #ccc;
  border-radius: 8px;
  .chat-item {
    // border: solid 1px rebeccapurple ;
    margin: 0 0 20px;
  }
  .c-i-header {
    width: 37px;
    // background-color: #177ff5;
    background-color: #4ba680;
    vertical-align: bottom;
    border-radius: 5px;
    padding: 2px;
    display: inline-block;
    float: left;
    margin: 0 10px;
  }
  .c-i-header-u {
    .c-i-header();
    background-color: #177ff5;
  }
  .c-p {
    float: right;
    width: 92%;
  }
}
.c-i-input {
    margin: 14px 0 0;
  }
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
.quan {
  margin: 10px;
}
@-webkit-keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
.loader-8 {
    width: 22px;
    height: 22px;
    border: 2px solid #4ba680;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    -webkit-animation: rotation 1s linear infinite;
    animation: rotation 1.1s linear infinite;
}
.loader-8:after {
    content: "";
    position: absolute;
    left: 10px;
    top: 11px;
    border: 5px solid transparent;
    border-right-color: #4ba680;
    transform: rotate(-40deg);
}
.intro {
  font-size: 18px;
  margin: 37px 0 100px;
  text-align: left;
}
.sec-info {
  margin: 0 26px;
}
.tip-info {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/chatgpt.vue